/* SMP catalogue activity v1.1. Consent-gated; no navigation interception. */
(() => {
  'use strict';

  if (window.__smpCatalogueTrackingV1) return;
  window.__smpCatalogueTrackingV1 = true;

  const destination = 'G-WKVCFPV0YZ';

  const seasons = new Set([
    'light-spring', 'warm-spring', 'clear-spring',
    'light-summer', 'cool-summer', 'soft-summer',
    'soft-autumn', 'warm-autumn', 'deep-autumn',
    'deep-winter', 'cool-winter', 'clear-winter'
  ]);

  const context = () => {
    const match = location.pathname.match(/\/collections\/([^/]+)/);
    const collection = match ? decodeURIComponent(match[1]) : 'unknown';

    return {
      smp_collection: collection,
      smp_season: seasons.has(collection) ? collection : 'unknown'
    };
  };

  const allowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  };

  const send = (name, params) => {
    if (
      !allowed() ||
      typeof window.gtag !== 'function' ||
      window.Shopify?.designMode
    ) return false;

    try {
      window.gtag('event', name, {
        ...params,
        ...context(),
        send_to: destination,
        smp_tracking_version: '1.1',
        transport_type: 'beacon'
      });
      return true;
    } catch (_) {
      return false;
    }
  };

  const attributes = element => ({
    smp_product_id: element.dataset.smpProductId,
    smp_vendor: (element.dataset.smpVendor || 'unknown').slice(0, 100),
    smp_placement: element.dataset.smpPlacement || 'product_page'
  });

    const newsletterPendingKey = 'smp_newsletter_pending_v1';
  let newsletterSent = false;
  let newsletterRetries = 0;
  let newsletterTimer;

  document.addEventListener('submit', event => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches('.newsletter-form') ||
      !allowed() ||
      window.Shopify?.designMode
    ) return;

    const emailField = form.querySelector(
      'input[id^="NewsletterForm--"]'
    );
    if (!emailField) return;

    try {
      sessionStorage.setItem(newsletterPendingKey, JSON.stringify({
        section: emailField.id.replace('NewsletterForm--', ''),
        path: location.pathname,
        submittedAt: Date.now()
      }));
    } catch (_) {
      // Skip tracking if browser storage is unavailable.
    }
  }, true);

  const newsletterSuccess = () => {
    if (newsletterSent || window.Shopify?.designMode) return;

    try {
      const pending = JSON.parse(
        sessionStorage.getItem(newsletterPendingKey) || 'null'
      );

      if (!pending) return;

      if (
        Date.now() - pending.submittedAt > 30 * 60 * 1000 ||
        pending.path !== location.pathname
      ) {
        sessionStorage.removeItem(newsletterPendingKey);
        return;
      }

      if (document.getElementById(
        'Newsletter-error--' + pending.section
      )) {
        sessionStorage.removeItem(newsletterPendingKey);
        return;
      }

      if (!document.getElementById(
        'Newsletter-success--' + pending.section
      )) return;

      if (!allowed()) return;

      newsletterSent = send('smp_newsletter_submit_success', {
        smp_placement: 'newsletter_section'
      });

      if (newsletterSent) {
        sessionStorage.removeItem(newsletterPendingKey);
        clearTimeout(newsletterTimer);
      } else if (!newsletterTimer && newsletterRetries < 20) {
        newsletterRetries++;
        newsletterTimer = setTimeout(() => {
          newsletterTimer = null;
          newsletterSuccess();
        }, 500);
      }
    } catch (_) {
      // Tracking must never interrupt the signup form.
    }
  };

  let viewSent = false;

  const productView = () => {
    if (viewSent) return;

    const product = document.querySelector('[data-smp-product-view]');

    if (product?.dataset.smpProductId) {
      viewSent = send('smp_product_view', attributes(product));
    }
  };

  let collectionViewSent = false;

  const collectionView = () => {
    if (collectionViewSent) return;

    // Collection pages only; excludes product pages within collections.
    if (!/^\/collections\/[^/]+\/?$/.test(location.pathname)) return;

    collectionViewSent = send('smp_collection_view', {
      smp_placement: 'collection_page'
    });
  };

    const pageViews = () => {
    productView();
    collectionView();
    newsletterSuccess();
  };

  document.addEventListener('visitorConsentCollected', pageViews);

  const activate = () => {
    pageViews();

    if (
      !window.Shopify?.customerPrivacy &&
      typeof window.Shopify?.loadFeatures === 'function'
    ) {
      window.Shopify.loadFeatures(
        [{name: 'consent-tracking-api', version: '0.1'}],
        error => {
          if (!error) pageViews();
        }
      );
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate, {once: true});
  } else {
    activate();
  }

  const click = event => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    if (event.type === 'click' && event.button !== 0) return;

    const link = event.target.closest?.('a[data-smp-retailer-link]');
    if (!link?.dataset.smpProductId) return;

    try {
      const target = new URL(link.href, location.href);

      if (
        !['https:', 'http:'].includes(target.protocol) ||
        target.origin === location.origin
      ) return;
    } catch (_) {
      return;
    }

    send('smp_retailer_click', attributes(link));
  };

  document.addEventListener('click', click, true);
  document.addEventListener('auxclick', click, true);
})();